import React from "react"
import { useLocation } from "react-router-dom"
import { matchPath } from "react-router-dom"

const routeToTitleMap: Record<string, string> = {
  "/home": "Home",
  "/projects": "Projects",
  "/tasks": "Tasks",
  "/todos": "To-dos",
  "/calendar": "Calendar",
  "/kanban": "Kanban Board",

  "/users/settings": "User Settings",
  "/users/welcome": "Welcome",

  "/projects/new": "New Project",
  "/projects/:projectId/basic": "Project Basic Info",
  "/projects/:projectId/calendar": "Project Calendar",
  "/projects/:projectId/gantt": "Project Gantt Chart",
  "/projects/:projectId/kanban": "Project Kanban Board",
  "/projects/:projectId/tasks": "Project Tasks",
  "/projects/:projectId/todos": "Project To-dos",
  "/projects/:projectId/reported-hours": "Project Reported Hours",
  "/projects/:projectId/dashboard": "Project Summary",
  "/projects/:projectId/settings": "Project Settings",
  "/project-templates/new": "New Project Template",

  "/tasks/:taskId/basic": "Task Basic Info",
  "/tasks/:taskId/notifications": "Task Notifications",
  "/tasks/:taskId/kanban": "Task Kanban Board",
  "/tasks/:taskId/todos": "Task To-dos",
  "/tasks/:taskId/subtasks": "Task Subtasks",
  "/tasks/:taskId/calendar": "Task Calendar",
  "/tasks/:taskId/reported-hours": "Task Reported Hours",

  "/orgs/new": "New Organization",
  "/orgs/welcome": "Welcome to Your Organization",
  "/orgs/billing": "Billing",
  "/orgs/settings": "Organization General Settings",
  "/orgs/settings/notifications": "Organization Notification Settings",
  "/orgs/settings/projects": "Organization Project Settings",
  "/orgs/settings/tasks": "Organization Task Settings",
  "/orgs/settings/holidays": "Organization Holidays Settings",
  "/orgs/members": "Organization Members",
  "/orgs/members/new": "New Member",
  "/orgs/suppliers": "Suppliers",
  "/orgs/suppliers/new": "New Supplier",
  "/orgs/customers": "Customers",
  "/orgs/customers/new": "New Customer",
  "/orgs/workspaces": "Workspaces",
  "/orgs/workspaces/new": "New Workspace",

  "/memberships/settings": "Membership Settings",
  "/customers/settings": "Customer Settings",
  "/suppliers/settings": "Supplier Settings",
  "/workspaces/members": "Workspace Members",
  "/workspaces/welcome": "Workspace",
  "/workspaces/settings": "Workspace Settings",

  "/login": "Login",
  "/signup": "Sign Up",
  "/forgot-password": "Forgot Password",
  "/reset-password/:token": "Reset Password",
  "/new-verification-code": "New Verification Code",
  "/account-verification": "Account Verification",
  "/deactivated": "Account Deactivated",

  "/invitations": "Invitations",
}

const usePageTitle = () => {
  const location = useLocation()
  const pageTitle = getPageTitle(location.pathname)

  React.useEffect(() => {
    if (document && document.title !== pageTitle) {
      document.title = pageTitle
    }
  }, [location.pathname, pageTitle])
}

const getPageTitle = (path: string): string => {
  for (const routePattern in routeToTitleMap) {
    const match = matchPath(path, { path: routePattern, exact: true })
    if (match) return `${routeToTitleMap[routePattern]} | Starbrix application`
  }

  return "Starbrix application"
}

export { usePageTitle }
